











































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("gaps", ["insurers"]),
})
export default class StatusFilter extends Vue {
  id = "insurer-filter-popover";
  target = "insurer-filter-target";
  insurers!: Array<any>;
  list = Array<any>();

  async checkInsurer() {
    this.list.forEach((ss) => {
      ss.checked = true;
    });
  }
  async uncheckInsurer() {
    this.list.forEach((ss) => {
      ss.checked = false;
    });
  }
  
  get checkedInsurers(): Array<any> {
    return this.list
      .filter((ss) => {
        return ss.checked;
      })
      .map((ss) => ss.id);
  }
 
  search() {
    var filter = JSON.parse(JSON.stringify(this.checkedInsurers));
    this.$store.commit("gaps/SET_REPORT_INSURERS_FILTER", filter);
    this.close();
  }
  clear() {
    this.uncheckInsurer();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { insurerList } = this.$store.state.gaps.filter.report;
    this.list = JSON.parse(JSON.stringify(this.insurers)).map((ss) => {
      ss.checked = insurerList.includes(ss.id);
      return ss;
    });
  }
}
